import React from "react";

export default function HechosSection({ fieldMeta, form, errors, setField }) {
  const chip = (key, manual = false) => {
    if (manual) return <span className="oa-chip-manual">MANUAL</span>;
    const m = fieldMeta?.(key);
    if (!m) return null;
    if (m.needsReview) return <span className="oa-tag-review" title={m.reviewReason}><span className="material-symbols-outlined" style={{ fontSize: 11, verticalAlign: "middle" }}>warning</span> REVISAR</span>;
    if (m.isAI) return <span className="oa-chip-ai">IA</span>;
    return null;
  };
  const fw = (key) => `oa-field${fieldMeta?.(key)?.needsReview ? " oa-field-review" : ""}`;

  return (
    <section className="oa-card">
      <div className="oa-card-head oa-head-split">
        <h2 className="oa-card-title">
          <span className="oa-card-icon">
            <i className="fa-solid fa-file-lines" />
          </span>
          HECHOS DE LA DEMANDA (NARRATIVA DEL TRABAJADOR)
        </h2>
      </div>

      <div className="oa-card-body">
        <div className="oa-grid-2 oa-mb-6">
          <div className={fw("responsable_despido")}>
            <label className="oa-label">
              Responsable del Despido (Persona imputada) {chip("responsable_despido")}
            </label>
            <input
              className={`oa-input ${errors.responsable_despido ? "oa-input-error" : ""}`}
              type="text"
              value={form.responsable_despido}
              onChange={(e) => setField("responsable_despido", e.target.value)}
            />
            {errors.responsable_despido ? <div className="oa-error">{errors.responsable_despido}</div> : null}
          </div>

          <div className={fw("jefes_inmediatos")}>
            <label className="oa-label">
              Jefes Inmediatos Mencionados {chip("jefes_inmediatos")}
            </label>
            <input
              type="text"
              className={`oa-input ${errors.jefes_inmediatos ? "oa-input-error" : ""}`}
              value={form.jefes_inmediatos}
              placeholder="Jefes Inmediatos"
              onChange={(e) => setField("jefes_inmediatos", e.target.value)}
            />
            {errors.jefes_inmediatos ? <div className="oa-error">{errors.jefes_inmediatos}</div> : null}
          </div>
        </div>
      </div>
    </section>
  );
}
